// @flow
import { AiOutlineArrowRight, AiOutlineArrowLeft } from 'react-icons/ai';
import {
  Box,
  Container,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import { InView } from 'react-intersection-observer';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { motion } from 'framer-motion';
import chunk from 'lodash.chunk';
import * as React from 'react';

import GalleryColumn from './services/gallery-column';

type Props = {
  items: Array<any>,
  title: string,
};

const useStyles = makeStyles((theme) => ({
  arrow: {
    '&.MuiIconButton-colorPrimary': {
      border: `1px solid ${theme.palette.primary.main}`,
    },

    '&:last-child': {
      marginLeft: theme.spacing(2),
    },
  },
}));

const Projects = ({ items, title }: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const variants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  };
  const [partitions, setPartitions] = React.useState(chunk(items, 4));
  const [index, setIndex] = React.useState(0);

  const next = () => setIndex(index + 1);

  const prev = () => setIndex(index - 1);

  React.useEffect(() => {
    if (matches) {
      setPartitions(chunk(items, 1));
    }
  }, [matches]);

  return (
    <>
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <InView threshold={0.8}>
              {({ inView, ref }) => (
                <Box
                  mt={6}
                  mb={6}
                  component={motion.div}
                  animate={inView ? 'visible' : 'hidden'}
                  ref={ref}
                  variants={variants}
                  transition={{ duration: 0.7, ease: 'easeOut' }}
                >
                  <Typography style={{ marginLeft: 20 }} variant="h2">
                    {title}&reg;
                  </Typography>
                </Box>
              )}
            </InView>
          </Grid>
        </Grid>
      </Container>
      <Grid container>
        {partitions[index]
          .filter((_, idx) => idx < 4)
          .map((node, idx) => (
            <Grid
              key={node.id}
              item
              xs={12}
              lg={3}
              container
              display="flex"
              flexDirection="column"
              alignContent="center"
              justifyContent="center"
            >
              <GalleryColumn
                index={idx}
                name={node.nombre}
                images={node.galeria}
                slug={node.slug}
              />
            </Grid>
          ))}
      </Grid>
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box display="flex" my={3} justifyContent="flex-end">
              {index !== 0 && (
                <IconButton
                  className={classes.arrow}
                  color="primary"
                  component="span"
                  onClick={prev}
                >
                  <AiOutlineArrowLeft />
                </IconButton>
              )}

              {index !== partitions.length - 1 && (
                <IconButton
                  className={classes.arrow}
                  color="primary"
                  component="span"
                  onClick={next}
                >
                  <AiOutlineArrowRight />
                </IconButton>
              )}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Projects;
